import { FC } from "react"
import { CreateWebsiteContainer } from "../components/create-website.container"

interface CreateWebsitePageProps {}
export const CreateWebsitePage: FC<CreateWebsitePageProps> = (props) => {
  return <CreateWebsiteContainer />
}